import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import MuiSpinner from '@mui/material/CircularProgress';
import Fab from '@mui/material/Fab';
import MenuItem from '@mui/material/MenuItem';
import Snackbar from '@mui/material/Snackbar';

import { brickOrange, darkGrey, fontWeight, lightGrey, turquoise } from '~/styles';

import { Button } from '../buttons';
import { BookmarkIcon } from '../icons';

export const MenuItemStyles = `
  font-size: 14px;
  width: 100%;
  text-transform: capitalize;
  justify-content: flex-start;
  align-items: center;
  font-weight: ${fontWeight.medium};
  line-height: 12px;
  letter-spacing: 0.05em;
  text-align: left;
  color: ${darkGrey};
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const StyledMenuItem = styled(MenuItem)`
  padding-left: 12px;
  padding-right: 12px;
  border-radius: 0;
  ${MenuItemStyles}
`;

export const UnderlinedMenuItem = styled(MenuItem)`
  position: relative;
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    height: 1px;
    background: ${lightGrey};
  }
`;

export const StyledSmallSpinner = styled(MuiSpinner)`
  &&& {
    color: ${brickOrange};
    margin-left: 10px;
    vertical-align: middle;
  }
`;

export const CornerFab = styled(Fab)`
  top: -13px;
  left: 93%;
  position: absolute;
  background-color: ${turquoise};
`;

export const StyledSnackbarButton = styled(Button)`
  && {
    height: 35px;
    min-width: fit-content;
    font-size: 12px;
    margin-right: auto;
    margin-left: auto;
    text-align: center;
  }
`;

export const StyledSnackbar = styled(Snackbar)`
  && .MuiSnackbarContent-action {
    margin-right: auto;
    margin-left: auto;
    padding-left: 0px;
  }
`;

export const StyledBookmarkIcon = styled(BookmarkIcon, {
  shouldForwardProp: prop => isPropValid(prop) && prop !== 'fillColor',
})<{ fillColor: string }>`
  && {
    color: ${({ fillColor }) => fillColor};
  }

  && .MuiSvgIcon-root {
    fill: ${({ fillColor }) => fillColor};
  }
`;
